/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AllergenDeleteModalMutationVariables = {|
  id: string
|};
export type AllergenDeleteModalMutationResponse = {|
  +allergenDelete: ?{|
    +deleted: ?boolean
  |}
|};
export type AllergenDeleteModalMutation = {|
  variables: AllergenDeleteModalMutationVariables,
  response: AllergenDeleteModalMutationResponse,
|};
*/


/*
mutation AllergenDeleteModalMutation(
  $id: ID!
) {
  allergenDelete(input: {id: $id}) {
    deleted
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "kind": "ObjectValue",
        "name": "input"
      }
    ],
    "concreteType": "AllergenDeletePayload",
    "kind": "LinkedField",
    "name": "allergenDelete",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deleted",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AllergenDeleteModalMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AllergenDeleteModalMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "AllergenDeleteModalMutation",
    "operationKind": "mutation",
    "text": "mutation AllergenDeleteModalMutation(\n  $id: ID!\n) {\n  allergenDelete(input: {id: $id}) {\n    deleted\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '4ee48a1997655d64bc2371687766b9f9';

module.exports = node;
